export default __webpack_public_path__ + "static/media/M41a.74d543b3.svg";